import { PageHeading } from 'app/components'
import { useFormularioAtual } from '../core/useFormularioAtual'

/**
 * Cabeçalho das telas de vínculos do formulário (por especialidade e por tipo de atendimento),
 * acima do <TableCard>: nome e descrição do formulário.
 */
export const FormularioHeading = () => {
  const { data: formulario, isError } = useFormularioAtual()

  const titulo = formulario?.nome ?? (isError ? 'Formulário' : 'Carregando formulário…')

  return <PageHeading title={titulo} description={formulario?.descricao} />
}
